import _ from 'lodash'

const groupDocumentsByEncounter = entries => {
  const result = {}
  if (!Array.isArray(entries)) {
    return result
  }
  _.forEach(entries, entry => {
    const reference = _.get(
      entry,
      'resource.context.encounter[0].reference',
      ''
    )
    if (typeof reference !== 'string' || reference.length === 0) {
      return
    }
    const encounterId = reference.split('/')[1]
    if (!encounterId) {
      return
    }
    if (!result[encounterId]) {
      result[encounterId] = []
    }
    result[encounterId].push(entry)
  })
  return result
}

export default groupDocumentsByEncounter
